<template>
  <div>
    <b-dropdown
      toggle-class="text-decoration-none"
      variant="transparent"
      class="competitor-dropbox"
    >
      <template v-slot:button-content>
        {{ $t("Webportal.CX.Dashboard.Exploration.Competitor") }}
      </template>
      <b-dropdown-item
        v-for="(competitor, index) in competitorList"
        :key="index"
        link-class="text-wrap"
        style="width:450px"
        @click="openCompetitor(competitor.CompetitorID)"
        >{{ competitor.Name }}</b-dropdown-item
      >
    </b-dropdown>
  </div>
</template>

<script>
export default {
  name: "CompetititorDropbox",

  props: {
    competitorList: Array,
  },

  methods: {
    openCompetitor(id) {
      this.$emit("openCompetitor", id);
    },
  },
};
</script>

<style lang="scss">

.competitor-dropbox {
  background: #ccc;
  border: 1px solid var(--border-color-secondary); 
  border-radius: 0.25rem;
}
</style>
